import { LeafletMap } from '../../maps'
import { useSelector } from '@ggs/store'

/**
 * @typedef {import('../../../definitions').LeafletPlace} LeafletPlace
 */

/**
 * @typedef {Object} DealerLocatorMapProps
 * @property {LeafletPlace[]} places
 */

/**
 * Dealer locator map display.
 * @param {DealerLocatorMapProps} props
 * @return {JSX.Element}
 */
export const DealerLocatorMap = ({ places }) => {
  const selectedDealerId = useSelector((state) => state.ui.searchDealer?.selectedResultId || '')
  return <LeafletMap places={places} isLoading={false} selectedPlaceId={selectedDealerId} />
}
